import { XIcon } from '@heroicons/react/outline';
import { Dialog, Slide } from '@mui/material'
import React from 'react'

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const Popup = ({ showPopup, closePopup, callComponant, quickView,closebtn }) => {
    return (
        <Dialog
            open={showPopup}
            TransitionComponent={Transition}
            keepMounted
            onClose={closePopup}
            aria-describedby="alert-dialog-slide-description"
            className={quickView ? 'quickview' : ''}
        >
            <div className='min-w-full sm:min-w-[330px]'>
                {closebtn === true && <button className={quickView ? 'popup-close-btn':'close-btn absolute top-[20px] right-[20px]'} onClick={closePopup}><XIcon className='w-4 h-4'/></button>}
                {callComponant}
            </div>
        </Dialog>
    )
}

export default Popup